module.exports = __webpack_public_path__ + "static/media/pouting-face-svgrepo-com.712e1afb.svg";